import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { Field } from 'redux-form';
import RenderLabelTimePicker from "../../common/reduxForm/RenderLabelTimePicker";
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import moment from "moment";
import Moment from "react-moment";

const styles = theme => ({
    card: {
        display: "flex",
        minHeight: "300px"
    },
    content: {
        flex: "1 0 auto"
    },
    addTime: {
        border: "1px solid #05b9a4",
        backgroundColor: "#05b9a4",
        color: "#fff",
        borderRadius: "50px",
        position: "absolute",
        bottom: "20px",
        left: "43%",
        "&:hover": {
            backgroundColor: "#05b9a4",
        }
    },
    breakTag: {
        textAlign: "center",
        marginTop: "10px"
    },
    breakInput: {
        width: "30px",
        margin: "0 5px"
    },
});

class TimeSlots extends Component {
    state = {
        breaks: 15,
    }

    componentDidMount() {
        const { fields } = this.props;
        if (!fields.length) {
            fields.push({ start_time: moment(), end_time: moment().add(30, 'minute') });
        }
    }

    onChangeBreaks = (e) => {
        const { name, value } = e.target;
        if (!isNaN(value)) {
            this.setState({ [name]: Number(value) })
        }
    }

    handleAddTime = (e) => {
        const { fields } = this.props;
        if (fields.length > 0) {
            const meetingtime = moment(fields.get(fields.length - 1).end_time).diff(moment(fields.get(fields.length - 1).start_time), 'minutes');
            const start_time = moment(fields.get(fields.length - 1).end_time, "HH:mm").add(this.state.breaks, 'minutes');
            const end_time = moment(start_time, "HH:mm").add(meetingtime, 'minutes');

            fields.push({ start_time, end_time })
        } else {

            fields.push({ start_time: moment(), end_time: moment().add(30, 'minute') })
        }
    }

    render() {
        const { breaks } = this.state;
        const { classes, fields: slots } = this.props;
        return (
            <Grid>
                {slots.map((slot, index, fields) => (
                    <Grid container key={index} className="slots">
                        <Grid item xs={3}>
                            <Field
                                name={`${slot}.start_time`}
                                component={RenderLabelTimePicker}
                                className="renderLableTimePicker"
                            />
                        </Grid>
                        <Grid item xs={3} >
                            <Grid container>
                                <Grid item xs={10} >
                                    <Field
                                        name={`${slot}.end_time`}
                                        component={RenderLabelTimePicker}
                                        className="renderLableTimePicker"
                                    />
                                </Grid>
                                <Grid item xs={2} className="deleteIcon">
                                    <Button onClick={() => { fields.remove(index) }}>
                                        <Icon>delete</Icon>
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                ))}

                <Grid container>
                    <Grid item xs={12} >
                        <Button
                            className={classes.addTime}
                            variant="outlined"
                            onClick={this.handleAddTime}>
                            Add Time
                        </Button>
                    </Grid>
                </Grid>
                <Grid container style={{ marginBottom: 15 }}>
                    <Grid item xs={12} className={classes.breakTag}>Breaks Between Slots</Grid>
                    <Grid item xs={12} className={classes.breakTag}>
                        <input
                            className={classes.breakInput}
                            name="breaks"
                            value={breaks}
                            onChange={this.onChangeBreaks} />
                        Min
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}


export default withStyles(styles)(TimeSlots)
